// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { DeletedVaultsOperations } from "./deletedVaults/index.js";
export { OperationsOperations } from "./operations/index.js";
export { PrivateLinkResourcesOperations } from "./privateLinkResources/index.js";
export { RecoveryServicesOperations } from "./recoveryServices/index.js";
export { RegisteredIdentitiesOperations } from "./registeredIdentities/index.js";
export { ReplicationUsagesOperations } from "./replicationUsages/index.js";
export { UsagesOperations } from "./usages/index.js";
export { VaultCertificatesOperations } from "./vaultCertificates/index.js";
export { VaultExtendedInfoOperations } from "./vaultExtendedInfo/index.js";
export { VaultsOperations } from "./vaults/index.js";
